import { createAsyncThunk } from "@reduxjs/toolkit";

import { postData } from "../../../services";

export const mobileOtpThunk = createAsyncThunk(
  "/otp",
  async (productRequest, { rejectWithValue }) => {
    try {
      const { headers, ...payload } = productRequest;
      const result = await postData(
        `/profile/login/request/otp`,
        payload,
        headers
      );

      return result.data;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data?.data });
    }
  }
);

export const abhaAddOtpThunk = createAsyncThunk(
  "/AbhaOtp",
  async (productRequest, { rejectWithValue }) => {
    try {
      const result = await postData(`/phr/web/login/abha/request/otp`, {
        ...productRequest,
      });
      return result.data;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data?.data });
    }
  }
);
export const abhaVerifyOtpThunk = createAsyncThunk(
  "/abhaVerify",
  async (productRequest, { rejectWithValue }) => {
    try {
      const result = await postData(`/phr/web/login/abha/verify`, {
        ...productRequest,
      });
      return result.data;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data?.data });
    }
  }
);

export const mobileAbhaSearchThunk = createAsyncThunk(
  "/abhaMobileSearch",
  async (productRequest, { rejectWithValue }) => {
    try {
      const result = await postData(`/profile/account/abha/search`, {
        ...productRequest,
      });
      return result.data;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data?.data });
    }
  }
);

export const abhaSearchThunk = createAsyncThunk(
  "/abhaSearch",
  async (productRequest, { rejectWithValue }) => {
    try {
      const result = await postData(`/phr/web/login/abha/search`, {
        ...productRequest,
      });
      return result.data;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data?.data });
    }
  }
);

export const verifyOtpThunk = createAsyncThunk(
  "/verifyOtp",
  async (productRequest, { rejectWithValue }) => {
    try {
      const result = await postData(`/profile/login/verify`, {
        ...productRequest,
      });
      return result.data;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data?.data });
    }
  }
);

// export const downloadAwardExcelThunk = createAsyncThunk(
//   "/downloadAwardExcel",
//   async (productRequest, { rejectWithValue }) => {
//     try {
//       const result = await postExcelDownload(`/cases/downloadAwardsExcel`, {
//         ...productRequest,
//       });
//       return result.data;
//     } catch (err) {
//       return rejectWithValue({ error: err?.response?.data });
//     }
//   }
// );
